// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i9oQ","col":"styles_col__2AclV"};